export type LeadKind = "website_review" | "consultation"
export type LeadStatus = "new" | "in_progress" | "responded" | "converted" | "closed"

export type AdminLeadSummary = {
  id: number
  kind: LeadKind
  status: LeadStatus
  locale: "hr" | "en"
  contact_name: string
  email: string
  company_name: string
  website_url: string | null
  created_at: string
  requested_start_at: string | null
  response_deadline: string | null
  response_deadline_state: "due" | "overdue" | null
}

export type AdminLeadDetail = AdminLeadSummary & {
  message: string | null
  confirmed_start_at: string | null
  responded_at: string | null
  consultation_confirmation_email_state: "pending" | "delivering" | "sent" | "uncertain" | null
  consultation_confirmation_email_attempted_at: string | null
  consultation_confirmation_email_sent_at: string | null
  posthog_distinct_id: string | null
  posthog_behavior_url: string | null
  details: Record<string, unknown>
  updated_at: string
  allowed_statuses: LeadStatus[]
}

export type ConsultationConfirmationSchedule = {
  dates: { value: string; label: string }[]
  times: string[]
  requested_date: string
  requested_time: string
  selected_date: string
  selected_time: string
}

export const LEAD_KIND_LABELS: Record<LeadKind, string> = {
  website_review: "Website Review",
  consultation: "Consultation Request",
}

export const LEAD_STATUS_LABELS: Record<LeadStatus, string> = {
  new: "New",
  in_progress: "In progress",
  responded: "Responded",
  converted: "Converted",
  closed: "Closed",
}

export function formatAdminDate(iso: string | null, includeTime = true) {
  if (!iso) return "—"

  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    hour: includeTime ? "2-digit" : undefined,
    minute: includeTime ? "2-digit" : undefined,
    month: "short",
    timeZone: "Europe/Zagreb",
    timeZoneName: includeTime ? "short" : undefined,
    year: "numeric",
  }).format(new Date(iso))
}
